module.exports = __webpack_public_path__ + "img/fig24.115a2a9c.jpg";